<script setup lang="ts">
import OpenCloseIcon from "@/views/blocks/common/OpenCloseIcon.vue";

const { textColor } = defineProps<{ textColor: string }>();

const emit = defineEmits<{
    openMenu: [];
}>();

const handleOpen = () => {
    emit("openMenu");
};
</script>

<template>
    <button
        type="button"
        class="inline-flex items-center justify-center lg:hidden rounded-md"
        @click="handleOpen"
    >
        <span class="sr-only">Open main menu</span>
        <OpenCloseIcon :is-open="false" />
    </button>
</template>

<style scoped>
button {
    color: v-bind(textColor);
}

button:hover {
    color: color-mix(in srgb, v-bind(textColor) 90%, transparent);
}

button:focus-visible {
    outline: 1px dotted v-bind(textColor);
    outline-offset: 2px;
}
</style>
